<template>
  <div>
      <v-row style="margin-top: 10px">
        <v-col cols="12" md="12" xs="12">
          <v-chip color="green" label text-color="white" class="mb-2">{{ description }}</v-chip>
        </v-col>
        <v-col cols="12" md="3" v-if="field !== null">
          <v-select :items="field.sports" label="A cosa vuoi giocare?" item-text="name" item-value="_id"
                    outlined
                    v-model="sport_selected" dense hide-details prepend-icon="mdi-stadium-variant">
            <template v-slot:selection="{ item, index }">
              <img :src="item.icon" width="20" class="mr-3" :alt="item.name"/> {{ item.name }}
            </template>
            <template v-slot:item="{ active, item, attrs, on }">
              <img :src="item.icon" width="20" class="mr-3" :alt="item.name"/> {{ item.name }}
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-menu
              ref="menu_date_search"
              v-model="menu_date_search"
              :return-value.sync="date_search"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="dateRangeText"
                  label="Intervallo Date"
                  prepend-icon="mdi-calendar"
                  append-icon="mdi-close"
                  @click:append="getCalendar(true)"
                  outlined
                  dense
                  hint="Min 7 e Max 28 giorni"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="date_search"
                range
                scrollable
                no-title
                :first-day-of-week="1"
            >
              <v-spacer></v-spacer>
              <v-btn
                  text
                  color="primary"
                  @click="menu_date_search = false"
              >
                Annulla
              </v-btn>
              <v-btn
                  text
                  color="primary"
                  @click="$refs.menu_date_search.save(date_search);getCalendar()"
              >
                Ok
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="3" offset-md="3">
          <div class="text-right">
            <v-select :append-outer-icon="(week_selected > 0) ? 'mdi-arrow-left':''"
                      :prepend-icon="(week_selected < weeks_num-1) ? 'mdi-arrow-right':''"
                      :items="weeks" v-model="week_selected" label="Settimana selezionata"
                      outlined item-value="ref"
                      @change="changeWeek('none')"
                      @click:append-outer="changeWeek('minus')"
                      @click:prepend="changeWeek('plus')" dense
                      :item-text="item =>`${formatDate(item.start_date)} - ${formatDate(item.end_date)}`"
                      hide-details
            ></v-select>
          </div>
        </v-col>
        <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">

          <v-card v-if="calendar !== null && sport_selected !== null" class="calendar-full">
            <v-simple-table fixed-header height="700px">
              <template v-slot:default>
                <thead>
                <tr>
                  <template v-for="day in visible">
                    <th>
                      <v-btn color="primary" block small>
                        {{ new Date(day.date).toLocaleDateString('it-IT', {weekday: 'short'}) }}
                        <span style="font-size: 24px;margin: 0 15px;">
                                                  {{ new Date(day.date).getDate() }}
                                              </span>
                        {{ new Date(day.date).toLocaleDateString('it-IT', {month: 'short'}) }}
                      </v-btn>
                    </th>
                  </template>
                </tr>
                </thead>
                <tbody>
                <template v-for="(n,i) in master_calendar_depth">
                  <tr>
                    <template v-for="day in visible">
                      <td style="padding: 0 6px">
                        <template v-if="day.slots[i]">
                          <template v-if="day.slots[i].booked || !day.slots[i].active">
                            <template v-if="!day.slots[i].booked">
                              <v-btn depressed color="error" outlined disabled block>
                                <span class="time-slot" :style="(day.slots[i].closed)?'color:#ffacac':''">{{ day.slots[i].start }} - {{ day.slots[i].end }} <br/> <small v-if="day.slots[i].closed" style="font-size: 9px">CHIUSO</small></span>
                              </v-btn>
                              <div></div>
                            </template>
                            <template v-else>
                              <div :class="(day.slots[i].fixed_booked || day.slots[i].from_fixed_booking)?'orange':'info'" class="white--text" @click="bookNow(day.slots[i],day.slots[i-1],day.slots[i+1])" style="cursor: pointer; border-radius: 5px">
                                     <span class="time-slot" style="max-width: 140px; margin: 0 auto; min-height: 45px">
                                      <v-icon v-if="day.slots[i].added_30_min_before || day.slots[i].added_30_min_after" small>mdi-clock-plus-outline</v-icon>
                                      {{ day.slots[i].start }} - {{ day.slots[i].end }} <br/>
                                       <div style="font-size: 13px; font-weight: normal">
                                         <template v-if="day.slots[i].user_id && day.slots[i].customer && day.slots[i].customer.length">
                                          <v-icon x-small color="white">mdi-account</v-icon> {{ day.slots[i].customer[0].name }} {{ day.slots[i].customer[0].surname }}
                                        </template>
                                        <template v-else-if="day.slots[i].user_id">
                                          <v-icon x-small color="white">mdi-account</v-icon> Utente eliminato
                                        </template>
                                        <template v-else>
                                          <v-icon x-small color="white">mdi-file-document-edit-outline</v-icon> {{ removeText(day.slots[i].note, 'Prenotazione Manuale') }}
                                        </template>
                                         <template v-if="(day.slots[i].fixed_booked || day.slots[i].from_fixed_booking) && day.slots[i].note && !day.slots[i].note.toLowerCase().includes('fisso')">
                                           <p>Fisso</p>
                                         </template>
                                       </div>
                                    </span>
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            <template v-if="day.slots[i].promo && !day.slots[i].promo_sa">
                              <v-alert color="primary" outlined block class="btn-slot promo"
                                       @click="bookNow(day.slots[i],day.slots[i-1],day.slots[i+1])">
                                                                    <span class="promo-amount"
                                                                          v-if="day.slots[i].promo">
                                                                     -{{ day.slots[i].promo.value }}{{
                                                                        (day.slots[i].promo.type === 'fixed') ? '€' : '%'
                                                                      }}
                                                                    </span>
                                <span class="time-slot">{{
                                    day.slots[i].start
                                  }} - {{ day.slots[i].end }}</span>
                                <span class="price-promo">{{
                                    getPrice(day.slots[i], 'total').toFixed(2)
                                  }} €</span>
                                <span v-if="getPrice(day.slots[i], 'online') === 0" class="label-pay">
                                                                    Pagamento Al Campo
                                                                </span>
                                <span v-else-if="getPrice(day.slots[i], 'center') === 0" class="label-pay">
                                                                Paghi comodo online
                                                                </span>
                                <span v-else style="font-size: 10px;display: block;text-align: center">
                                                                    di cui {{
                                    getPrice(day.slots[i], 'online').toFixed(2)
                                  }} € online
                                                                </span>
                              </v-alert>
                            </template>
                            <template v-else-if="day.slots[i].promo_sa">
                              <v-alert color="primary" outlined block class="btn-slot promo_sa">
                                                                <span class="promo-amount" v-if="day.slots[i].promo">
                                                                    -{{
                                                                    day.slots[i].promo.value
                                                                  }}{{
                                                                    (day.slots[i].promo.type === 'fixed') ? '€' : '%'
                                                                  }}</span>
                                <span class="time-slot">{{ day.slots[i].start }} - {{ day.slots[i].end }}</span>
                                <span class="price-promo_sa">{{ getPrice(day.slots[i], 'total').toFixed(2) }} €</span>
                                <span class="label-pay-yellow blink">PROMO PER POCHE ORE</span>
                              </v-alert>
                            </template>
                            <template v-else>
                              <v-alert color="primary" outlined block class="btn-slot normal">
                                <div @click="bookNow(day.slots[i],day.slots[i-1],day.slots[i+1])">
                                  <span class="time-slot">{{ day.slots[i].start }} - {{ day.slots[i].end }}</span>
                                  <span class="price">{{ getPrice(day.slots[i], 'total').toFixed(2) }} €</span>
                                  <span v-if="getPrice(day.slots[i], 'online') === 0" class="label-pay">Pagamento Al Campo</span>
                                  <span v-else-if="getPrice(day.slots[i], 'center') === 0" class="label-pay">Paghi comodo online</span>
                                  <span v-else style="font-size: 10px;display: block;text-align: center">di cui {{
                                      getPrice(day.slots[i], 'online').toFixed(2)
                                    }} € online</span>
                                </div>
                              </v-alert>
                            </template>
                          </template>
                          <template
                              v-if="!day.slots[i].booked && getAvailabilityNow(day, day.slots[i].slot_id) && !day.slots[i].overlap && !day.slots[i].exclude && !day.slots[i].closed">
                            <div style="text-align: center;margin-top: -6px;">
                              <v-btn elevation="2" raised tile x-small @click="overrideSlot(day, day.slots[i])"
                                     color="error">CONFIGURA
                              </v-btn>
                            </div>
                          </template>
                        </template>
                        <template v-else>

                        </template>
                      </td>
                    </template>
                  </tr>
                </template>
                </tbody>
              </template>
            </v-simple-table>

          </v-card>
        </v-col>
        <ModalCheckout @message="refresh"/>
        <v-dialog v-model="dialog_promo" persistent max-width="800px" v-if="slot_to_override">
          <v-card>
            <v-card-title>
              <span class="font-weight-bold">{{ this.override_title }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <template>
                    <v-flex md12 xs12 class="d-flex">
                      <v-chip color="primary" label small text-color="white">{{ $t('status') }}</v-chip>
                    </v-flex>
                    <v-flex md12 xs12 class="d-flex mt-2 mb-2">
                      <v-checkbox dense hide-details v-model="slot_to_override.status_slot"
                                  :label="(slot_to_override.status_slot) ? this.$t('enabled') : this.$t('disabled')"
                                  style="margin-top: 0">
                      </v-checkbox>
                    </v-flex>
                    <v-flex md12 xs12 class="d-flex">
                      <v-chip color="primary" label small text-color="white">{{ $t('splitPayment') }}
                      </v-chip>
                    </v-flex>

                    <v-flex md12 xs12 class="d-flex mt-2 mb-2">
                      <v-checkbox dense hide-details v-model="slot_to_override.split_payment_custom"
                                  :label="this.$t('enableSplitPaymentCustom')" style="margin-top: 0">
                      </v-checkbox>
                    </v-flex>

                    <template v-if="slot_to_override.split_payment_custom">
                      <v-flex xs12 md4 class="pl-4 pr-4">
                        <v-select :items="split_payment_types" :label="$t('mode')"
                                  @change="applySplitOverride"
                                  v-model="split_payment_override_selected"></v-select>
                      </v-flex>
                      <v-flex xs12 md4 class="pl-4 pr-4">
                        <v-text-field type="number" :label="$t('onlinePercentage')"
                                      v-model="slot_to_override.split_payment.online_percentage"
                                      prefix="%" step="1"
                                      @input="changePercentageOverride('online')" min="0"
                                      max="100"></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 class="pl-4 pr-4">
                        <v-text-field type="number" :label="$t('centerPercentage')"
                                      v-model="slot_to_override.split_payment.center_percentage"
                                      prefix="%" step="1"
                                      @input="changePercentageOverride('center')" min="0"
                                      max="100"></v-text-field>
                      </v-flex>
                    </template>
                    <v-flex xs12 md12 class="d-flex">
                      <v-chip color="primary" label small text-color="white">{{ $tc('promotion') }}
                      </v-chip>
                    </v-flex>
                    <v-flex xs12 md12 class="d-flex mt-2 mb-2">
                      <v-checkbox dense hide-details v-model="slot_to_override.promo_custom"
                                  :label="this.$t('enablePromoCustom')" style="margin-top: 0"
                                  @change="changePromoCustom">
                      </v-checkbox>
                    </v-flex>
                    <template v-if="slot_to_override.promo_custom">
                      <v-flex xs12 md4 class="pl-4 pr-4">
                        <v-select :items="promotion_types" :label="$t('mode')"
                                  v-model="slot_to_override.promo.type"
                                  @change="calculateTotalsOverride"></v-select>
                      </v-flex>
                      <v-flex xs12 md4 class="pl-4 pr-4" v-if="slot_to_override.promo.type !== null">
                        <v-text-field type="number" :label="$t('value')"
                                      v-model="slot_to_override.promo.value"
                                      :prefix="(slot_to_override.promo.type === 'fixed') ? '-':'%'"
                                      step="1"
                                      @input="calculateTotalsOverride" min="0" max="100"></v-text-field>
                      </v-flex>
                    </template>


                    <v-flex md12 class="d-flex pt-5">
                      <v-chip color="primary" label small text-color="white">{{$t('settings')}} {{$t('PromoCode')}}</v-chip>
                    </v-flex>

                    <v-flex md6 class="pr-4">
                      <v-checkbox
                          v-model="slot_to_override.enable_promo_code_promo_sa_global"
                          label="Accetta Promo Code uCamp"
                          :readonly="!this.getUser.super_admin"
                          :disabled="!this.getUser.super_admin"
                      ></v-checkbox>
                    </v-flex>

                    <v-flex md6 class="pl-4 pr-4">
                      <v-checkbox
                          v-model="slot_to_override.enable_promo_code_promo_center"
                          label="Accetta Promo Code Centro"
                      ></v-checkbox>
                    </v-flex>

                    <v-flex xs12 md12 class="d-flex">
                      <v-chip color="primary" label small text-color="white">{{ $t('preview') }}</v-chip>
                    </v-flex>

                    <v-flex xs12 md12 class="pl-4 pr-4 pb-3">
                      <v-simple-table dense>
                        <thead>
                        <tr>
                          <th class="text-left">Sport</th>
                          <th class="text-left">Da Pagare Online</th>
                          <th class="text-left">Da Pagare al Campo</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="preview_ov in preview_price_override"
                            :key="'preview_ov_'+preview_ov.sport_id">
                          <td class="font-weight-bold">{{ getSportName(preview_ov.sport_id) }}</td>
                          <td>
                          <span v-bind:style="[+preview_ov.value_ac < +field.rules.min_price? {'color':'red'} : {}]">
                          <template v-if="+preview_ov.value_ac < +field.rules.min_price">*</template> {{
                              preview_ov.value_ac.toFixed(2)
                            }} €
                          </span>
                          </td>
                          <td>{{ preview_ov.value_ce.toFixed(2) }} €</td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                      <small style="color: red">* Al di sotto del minimo costo garantito</small>

                    </v-flex>

                  </template>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="buttons-group-mobile">
              <v-btn color="secondary" text @click="dialog_promo = false">
                {{ $t('cancel') }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="deletePromotion()" v-if="slot_to_override.id !== ''">
                {{ $t('delete') }}
              </v-btn>
              <v-btn color="primary" @click="updatePromotion()" v-if="slot_to_override.id !== ''">
                {{ $t('save') }}
              </v-btn>
              <v-btn color="primary" @click="savePromotion()" v-if="slot_to_override.id === ''">
                {{ $t('insert') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
import _ from 'lodash'
import ModalCheckout from "@/components/admin/Checkout";
import TitlePage from "@/components/utils/TitlePage.vue";

export default {
  name: "LiveCalendar",
  components: {ModalCheckout, TitlePage},
  props: ['selected_field'],
  data() {
    return {
      description: '',
      week_selected: 0,
      weeks_num: null,
      weeks: null,
      visible: null,
      center: null,
      field: null,
      calendar: null,
      sport_selected: null,
      master_calendar_depth: 0,
      slot_selected: '',
      override_title: '',
      slot_to_override: null,
      dialog_promo: false,
      preview_price: [],
      preview_price_override: [],
      split_payment_types: [
        {'text': this.$t('payDivide'), 'value': 'pay_divide'},
        {'text': this.$t('payCenter'), 'value': 'pay_center'},
        {'text': this.$t('payOnline'), 'value': 'pay_online'}
      ],
      promotion_types: [
        {'text': '', 'value': null},
        {'text': this.$t('fixed'), 'value': 'fixed'},
        {'text': this.$t('percentage'), 'value': 'percentage'},
      ],
      split_payment_override_selected: '',
      sports: [],
      date_search: [],
      menu_date_search: false,
      minDate: new Date().toISOString().slice(0, 10),
    };
  },
  computed: {
    ...mapGetters({
      'getEndpoint': 'settings/getEndpoint',
      'getUser': 'user/getUser',
    }),
    dateRangeText() {
      return `${this.formatDateHuman(this.date_search[0])} ~ ${this.formatDateHuman(this.date_search[1])}`
    }
  },
  watch: {
    selected_field: async function (newVal) {
      this.selected_field = newVal   // or this.openPopup(newVal) is this suits
      await this.showCalendar()
    }
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'getFields': 'fields/getCompleteList',
      'fetchCalendar': 'bookings/fetchCalendar',
      'setDialogCheckout': 'checkout/setDialogCheckout',
      'setBooking': 'checkout/setBooking',
      'setBookingOriginal': 'checkout/setBookingOriginal',
      'storePromotion': 'promotions/store',
      'updatePromo': 'promotions/update',
      'deletePromo': 'promotions/delete',
      'getActivePromotions': 'promotions/getActivePromotions',
      'getActiveBookings': 'bookings/getActiveBookings',
    }),

    async showCalendar() {
      this.setLoading(true);
      let result = await this.fetchCalendar({id: this.selected_field})
      this.weeks_num = result.weeks_num
      this.weeks = result.weeks
      this.visible = result.visible
      for (let i = 0; i < 7; i++) {
        if (this.visible[i].slots.length > this.master_calendar_depth) {
          this.master_calendar_depth = this.visible[i].slots.length
        }
      }
      this.preview_price = []
      this.preview_price_override = []

      this.center = result.center
      this.field = result.field
      this.sports = result.field.sports
      result.field.sports.map((s) => {
        this.preview_price.push({
          sport_id: s._id,
          value_ac: 0.00,
          value_ce: 0.00,
          sport: this.getSportName(s)
        })
        this.preview_price_override.push({
          sport_id: s._id,
          value_ac: 0.00,
          value_ce: 0.00,
          sport: this.getSportName(s._id)
        })
      })
      this.calendar = result.calendar
      this.sport_selected = result.sport_selected
      this.description = this.center.name + ' > ' + this.field.name
      await this.fetchPromotions()

      let date_start = new Date()
      let date_end = new Date()
      date_end.setDate(date_end.getDate() + this.field.rules.calendar_days_view)
      this.date_search = [date_start.toISOString().split('T')[0], date_end.toISOString().split('T')[0]]
      this.setLoading(false);
    },
    async getCalendar(reset = null) {
      this.setLoading(true);

      if (reset) {
        let date_start = new Date()
        let date_end = new Date()
        date_end.setDate(date_end.getDate() + this.field.rules.calendar_days_view)
        this.date_search = [date_start.toISOString().split('T')[0], date_end.toISOString().split('T')[0]]
      }

      if (!this.date_search[0] || !this.date_search[1]) {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Errore: Selezionare una data di Inizio ed una data di Fine'
        })
        this.setLoading(false);
        return false
      }

      let start = new Date(this.date_search[0])
      let end = new Date(this.date_search[1])
      if (end < start) {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Errore: La data di fine è antecedente alla data di inizio'
        })
        this.setLoading(false);
        return false
      }

      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays < 7 || diffDays > 28) {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Errore: Selezionare un\'intervallo con durata tra 7 e 28 giorni'
        })
        this.setLoading(false);
        return false
      }

      let result = await this.fetchCalendar({id: this.field._id, date: this.date_search[0], days: diffDays + 1})
      this.weeks_num = result.weeks_num
      this.weeks = result.weeks
      this.visible = result.visible
      for (let i = 0; i < 7; i++) {
        if (this.visible[i].slots.length > this.master_calendar_depth) {
          this.master_calendar_depth = this.visible[i].slots.length
        }
      }

      this.center = result.center
      this.field = result.field
      this.sports = result.field.sports
      this.preview_price = []
      this.preview_price_override = []

      result.field.sports.map((s) => {
        this.preview_price.push({
          sport_id: s._id,
          value_ac: 0.00,
          value_ce: 0.00,
          sport: this.getSportName(s)
        })
        this.preview_price_override.push({
          sport_id: s._id,
          value_ac: 0.00,
          value_ce: 0.00,
          sport: this.getSportName(s._id)
        })
      })
      this.calendar = result.calendar
      this.sport_selected = result.sport_selected
      this.description = this.center.name + ' > ' + this.field.name
      await this.fetchPromotions()

      this.$forceUpdate();

      this.setLoading(false);

    },
    async overrideSlot(day, slot) {

      let find_promo = _.find(this.promotions_active, {'slot_id': slot.slot_id})

      if (slot.promo_sa && !this.getUser.super_admin) {
        return
      }

      this.override_title = new Date(day.date).toLocaleDateString() + ' | ' + slot.start + ' - ' + slot.end + ' | ' + this.description
      this.slot_selected = slot.slot_id

      this.slot_to_override = {
        center_id: this.center._id,
        field_id: this.field._id,
        slot_id: slot.slot_id,
        date: new Date(day.date).toISOString(),
        start_time: slot.start,
        end_time: slot.end,
        split_payment_custom: (slot.split_payment_custom) ? slot.split_payment_custom : false,
        split_payment: {
          online_percentage: (slot.split_payment && slot.split_payment.online_percentage) ? +slot.split_payment.online_percentage : 0.00,
          center_percentage: (slot.split_payment && slot.split_payment.center_percentage) ? +slot.split_payment.center_percentage : 0.00,
        },
        promo_custom: !!(slot.promo),
        promo_sa: (slot.promo_sa) ? slot.promo_sa : false,
        promo: {
          type: (slot.promo && slot.promo.type) ? slot.promo.type : '',
          value: (slot.promo && slot.promo.value) ? +slot.promo.value : 0.00,
        },
        status_slot: slot.active,
        id: '',
        slot_price: (slot.slot_price) ? slot.slot_price : null,
        enable_promo_code_promo_sa_global : (slot.enable_promo_code_promo_sa_global),
        enable_promo_code_promo_center : (slot.enable_promo_code_promo_center)
      }

      if (find_promo) {
        this.slot_to_override.id = find_promo._id
        this.slot_to_override.enable_promo_code_promo_sa_global = (find_promo.enable_promo_code_promo_sa_global)
        this.slot_to_override.enable_promo_code_promo_center = (find_promo.enable_promo_code_promo_center)
      }

      await this.calculateTotalsOverride()
      this.dialog_promo = true
    },
    changeWeek(mode) {
      if (mode === 'minus') {
        if (this.week_selected - 1 >= 0) {
          this.week_selected--
          this.refactoringCalendar(this.weeks[this.week_selected].start, this.weeks[this.week_selected].end)
        }
      } else if (mode === 'plus') {
        if (this.week_selected + 1 < this.weeks_num) {
          this.week_selected++
          this.refactoringCalendar(this.weeks[this.week_selected].start, this.weeks[this.week_selected].end)
        }
      } else {
        this.refactoringCalendar(this.weeks[this.week_selected].start, this.weeks[this.week_selected].end)
      }
    },
    async bookNow(slot, slot_before = null, slot_after = null) {
      if (slot.active && !slot.booked) {

        let slot_to_book = JSON.parse(JSON.stringify(slot))

        slot_to_book.prices.map((p) => {
          let ac = JSON.parse(JSON.stringify(p.value_ac))
          p.value_ce = (+p.value_ce) + (+ac)
          p.value_ac = 0;
        })

        slot_to_book.split_payment.online_percentage = 0
        slot_to_book.split_payment.center_percentage = 100
        slot_to_book.promo = null
        slot_to_book.promo_sa = false
        slot_to_book.promo_sa_global = false
        slot_to_book.split_payment_custom = false

        slot_to_book.center = this.center._id
        slot_to_book.center_info = this.center
        slot_to_book.field = this.field._id
        slot_to_book.field_info = this.field
        slot_to_book.sport_selected = this.sport_selected
        slot_to_book.user = null
        slot_to_book.note = ''

        if (this.field.half_hour_enabled) {
          slot_to_book.slot_before = slot_before
          slot_to_book.slot_after = slot_after
          slot_to_book.half_hour_enabled = true
          slot_to_book.half_hour_price = JSON.parse(JSON.stringify(this.field.half_hour_price))
          slot_to_book.added_30_min_before = false
          slot_to_book.added_30_min_after = false
        } else {
          slot_to_book.slot_before = null
          slot_to_book.slot_after = null
          slot_to_book.half_hour_enabled = null
          slot_to_book.half_hour_price = null
          slot_to_book.added_30_min_before = false
          slot_to_book.added_30_min_after = false
        }

        await this.setBooking(slot_to_book)
        await this.setBookingOriginal(slot_to_book)
        await this.setDialogCheckout(true)
      } else {
        if(slot.booking_id){
          this.$router.push('/bookings/edit/' + slot.booking_id)
        }else {
          return
        }

      }
    },
    async calculateTotalsOverride() {

      this.preview_price_override = JSON.parse(JSON.stringify(this.preview_price))

      this.preview_price_override.map((p) => {
        let prices = (this.slot_to_override.slot_price) ? this.slot_to_override.slot_price : this.field.price
        let find = _.find(prices, {'sport_id': p.sport_id})
        let price = JSON.parse(JSON.stringify(find))

        if (this.slot_to_override.promo_custom) {
          if (this.slot_to_override.promo.type === 'fixed' && this.slot_to_override.promo.value >= 0.00) {
            price.value = +price.value - this.slot_to_override.promo.value
          } else if (this.slot_to_override.promo.type === 'percentage' && this.slot_to_override.promo.value >= 0.00) {
            let discount_unit = _.round(+price.value / 100, 3);
            let discount = _.round(+discount_unit * (+this.slot_to_override.promo.value), 2);
            price.value = +price.value - discount
          }
        }


        let online
        let center
        let unit = _.round(+price.value / 100, 3);
        if (this.slot_to_override.split_payment_custom) {
          online = _.round(+unit * (+this.slot_to_override.split_payment.online_percentage), 2);
          center = _.round(+unit * (+this.slot_to_override.split_payment.center_percentage), 2);
        } else {
          online = _.round(+unit * (+this.field.split_payment_master.online_percentage), 2);
          center = _.round(+unit * (+this.field.split_payment_master.center_percentage), 2);
        }

        p.value_ac = online
        p.value_ce = center
      })
    },
    async savePromotion() {
      if (this.slot_to_override.split_payment.online_percentage > 0 && (!this.center.configurations || (!this.center.configurations.paypal_enabled || this.center.configurations.paypal_client_id === '' || this.center.configurations.paypal_client_secret === ''))) {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Non è possibile abilitare pagamenti online senza aver configurato correttamente un metodo di pagamento per il centro sportivo'
        })
        return
      }
      await this.setLoading(true);
      let result = await this.storePromotion(this.slot_to_override)
      await this.setLoading(false);

      if (result.success) {

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('createSuccess')
        })

        this.dialog_promo = false
        await this.refresh()

      } else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: this.$t(result)
        })

      }


    },
    async updatePromotion() {
      if (this.slot_to_override.split_payment.online_percentage > 0 && (!this.center.configurations || (!this.center.configurations.paypal_enabled || this.center.configurations.paypal_client_id === '' || this.center.configurations.paypal_client_secret === ''))) {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Non è possibile abilitare pagamenti online senza aver configurato correttamente un metodo di pagamento per il centro sportivo'
        })
        return
      }
      await this.setLoading(true);
      let result = await this.updatePromo({id: this.slot_to_override.id, item: this.slot_to_override})
      await this.setLoading(false);

      if (result.success) {

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

        this.dialog_promo = false
        await this.refresh()

      } else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: this.$t(result)
        })

      }


    },
    async deletePromotion() {

      await this.setLoading(true);
      let result = await this.deletePromo({id: this.slot_to_override.id})
      await this.setLoading(false);

      if (result.success) {

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('deleteSuccess')
        })

        this.dialog_promo = false
        await this.refresh()

      } else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: this.$t(result)
        })

      }


    },
    async changePercentageOverride(type) {
      let total = 100.00
      if (type === 'online') {
        if (+this.slot_to_override.split_payment.online_percentage < 0) {
          this.slot_to_override.split_payment.online_percentage = 0.00
          this.slot_to_override.split_payment.center_percentage = 100.00
        } else if (+this.slot_to_override.split_payment.online_percentage > 100) {
          this.slot_to_override.split_payment.online_percentage = 100.00
          this.slot_to_override.split_payment.center_percentage = 0.00
        } else {
          this.slot_to_override.split_payment.center_percentage = +(total - (+this.slot_to_override.split_payment.online_percentage))
        }
      } else if (type === 'center') {
        if (+this.slot_to_override.split_payment.center_percentage < 0) {
          this.slot_to_override.split_payment.center_percentage = 0.00
          this.slot_to_override.split_payment.online_percentage = 100.00
        } else if (+this.slot_to_override.split_payment.center_percentage > 100) {
          this.slot_to_override.split_payment.center_percentage = 100.00
          this.slot_to_override.split_payment.online_percentage = 0.00
        } else {
          this.slot_to_override.split_payment.online_percentage = +(total - (+this.slot_to_override.split_payment.center_percentage))
        }
      }
      await this.calculateTotalsOverride()
      this.$forceUpdate();
    },
    async fetchPromotions() {
      let today = new Date();
      today.setHours(0, 0, 0, 0);
      let promo = await this.getActivePromotions({field_id: this.field._id, date: today.toISOString()})
      this.promotions_active = promo.result
    },
    changePromoSuperAdmin() {
      if (this.slot_to_override.promo_sa) {
        this.slot_to_override.split_payment.online_percentage = 100.00
        this.slot_to_override.split_payment.center_percentage = 0.00
        this.slot_to_override.split_payment_custom = true
        this.split_payment_override_selected = 'pay_online'
        this.calculateTotalsOverride()
      } else {
        this.slot_to_override.split_payment.online_percentage = (this.field.split_payment_master.online_percentage) ? this.field.split_payment_master.online_percentage : 50.00
        this.slot_to_override.split_payment.center_percentage = (this.field.split_payment_master.center_percentage) ? this.field.split_payment_master.center_percentage : 50.00
        this.slot_to_override.split_payment_custom = true
        this.split_payment_override_selected = ''
        this.calculateTotalsOverride()
      }
    },
    async applySplitOverride() {
      switch (this.split_payment_override_selected) {
        case "pay_divide": {
          this.slot_to_override.split_payment.online_percentage = 50.00
          this.slot_to_override.split_payment.center_percentage = 50.00
          await this.calculateTotalsOverride()
          break
        }
        case "pay_center": {
          this.slot_to_override.split_payment.online_percentage = 0.00
          this.slot_to_override.split_payment.center_percentage = 100.00
          await this.calculateTotalsOverride()
          break
        }
        case "pay_online": {
          this.slot_to_override.split_payment.online_percentage = 100.00
          this.slot_to_override.split_payment.center_percentage = 0.00
          await this.calculateTotalsOverride()
          break
        }
        default: {
          break
        }
      }
    },
    changePromoCustom() {
      if (this.slot_to_override.promo_custom) {

      } else {
        this.slot_to_override.promo.type = ''
        this.slot_to_override.promo.value = 0
        this.calculateTotalsOverride()
      }
    },
    getPrice(slot, type = 'online') {
      let find = _.find(slot.prices, {sport_id: this.sport_selected})
      if (!find) {
        return slot.slot_id
      } else {
        if (type === 'online') {
          return find.value_ac
        } else if (type === 'center') {
          return find.value_ce
        } else if (type === 'total') {
          return find.value_ac + find.value_ce
        }
      }
    },
    async refactoringCalendar(start, end) {
      let fallback = this.calendar.days[start]
      let fallback_clone = JSON.parse(JSON.stringify(fallback))

      await this.setLoading(true);

      this.visible = []
      let offset = 0;
      let last_date = ''

      for (let i = start; i <= end; i++) {
        if (this.calendar.days[i]) {
          last_date = this.calendar.days[i].date
          this.visible.push(this.calendar.days[i])
        } else {
          offset++
          let day = JSON.parse(JSON.stringify(fallback_clone))

          day.slots.map((s) => {
            s.active = false
            s.booked = false
            s.promo_sa = false
            s.promo = false
            s.exclude = true
            delete s.code
          })

          const date = new Date(last_date);
          date.setDate(date.getDate() + offset);
          day.date = date
          this.visible.push(day)
        }
      }
      await this.setLoading(false);
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    },
    formatDate(date_text) {
      let date = new Date(date_text)

      return [
        this.padTo2Digits(date.getDate()),
        this.padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join('/');
    },
    getSportName(_id) {
      let find = _.find(this.sports, {'_id': _id})
      if (find) {
        return find.name
      } else {
        return _id
      }
    },
    async refresh() {
      await this.showCalendar()
    },
    getAvailabilityNow(day, id) {
      let start_time = id.split(';')
      let split = start_time[3].split(':');
      const now = new Date();
      now.setMinutes(now.getMinutes() + this.field.rules.limit_time);
      let day_obj = new Date(day.date)
      day_obj.setHours(split[0], split[1], 0)
      return now <= day_obj;
    },
    formatDateHuman(my_date) {
      if (my_date) {
        let date = new Date(my_date)
        return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear()
      } else {
        return ''
      }
    },
    removeText(text, text2) {
      return text.replace(text2, '')
    }
  },
  async mounted() {
    this.setLoading(true);
    if (this.selected_field) {
      await this.showCalendar()
    }
    this.setLoading(false);
  }
}
</script>

<style scoped>
.link-center {
  color: #25a639;
  text-decoration: none;
}

.link-action-center {
  text-decoration: none;
  color: #25a639 !important;
  font-weight: 400;
}

.calendar-full .v-slide-group__next, .calendar-full .v-slide-group__prev {
  display: none;
}

.calendar-full .time-slot {
  font-weight: 700;
  font-size: 13px;
  width: 100%;
  display: block;
  text-align: center;
}

.calendar-full .price {
  width: 100%;
  display: block;
  text-align: center;
  color: #00752a;
  font-size: 13px;
  font-weight: 600;
}

.calendar-full .price-promo {
  width: 100%;
  display: block;
  text-align: center;
  color: red;
  font-size: 13px;
  font-weight: 600;
}

.calendar-full .price-promo_sa {
  width: 100%;
  display: block;
  text-align: center;
  color: #fff;
  font-size: 17px;
  font-weight: 600;
}

.calendar-full .label-pay {
  text-align: center;
  font-size: 10px;
  display: block;
  font-weight: 600;
  color: darkblue;
  text-transform: uppercase;
}

.calendar-full .btn-slot {
  padding: 0 8px;
  height: 60px;
  margin: 6px 0;
  border: none !important;
  cursor: pointer;
}

.calendar-full .btn-slot.promo_sa {
  background: #282b50 !important;
  color: #fff !important;
  animation: pulse 1.25s infinite ease-out;
}

.calendar-full .btn-slot.normal {
  background: #25a63936 !important;
}

.calendar-full .btn-slot.promo {
  background: rgb(40 43 80 / 10%) !important;
  animation: pulse-shadow 2s infinite;
}

.calendar-full .promo-amount {
  background: red;
  color: rgb(255, 255, 255);
  font-weight: 600;
  position: absolute;
  top: 0px;
  right: 0px;
  border-radius: 3px;
  font-size: 13px;
  padding: 0px 4px;
}

.calendar-full .label-pay-white {
  text-align: center;
  font-size: 10px;
  display: block;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
}

.calendar-full .label-pay-yellow {
  text-align: center;
  font-size: 10px;
  display: block;
  font-weight: 600;
  text-transform: uppercase;
  color: #baff3b;
}

.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1.0);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1.0);
  }
}

@keyframes pulse-shadow {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 2px rgba(206, 67, 67, 0.48);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 0px rgba(206, 67, 67, 0.48);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 2px rgba(206, 67, 67, 0.48);
  }
}
</style>